import { Mail, PhoneCall, Video, FileText } from "lucide-react";

export const ACTIVITY_TYPES = [
  { value: "call", label: "Call", icon: PhoneCall, color: "text-ism-teal" },
  { value: "email", label: "Email", icon: Mail, color: "text-green-400" },
  { value: "meeting", label: "Meeting", icon: Video, color: "text-gray-400" },
  { value: "note", label: "Note", icon: FileText, color: "text-yellow-400" },
];

export const STATUS_OPTIONS = ["new", "contacted", "qualified", "converted", "lost"];

export const EMPTY_ACTIVITY = { type: "note", subject: "", description: "", outcome: "" };

export const activityType = (value) => ACTIVITY_TYPES.find((t) => t.value === value) || ACTIVITY_TYPES[3];

export const editableFields = (lead) => ({
  status: lead.status || "new",
  notes: lead.notes || "",
  contactName: lead.contactName || "",
  contactTitle: lead.contactTitle || "",
  email: lead.email || "",
  phone: lead.phone || "",
});

export const getStatusColor = (status) => {
  switch (status) {
    case "converted": return "bg-green-500/20 text-green-400 border-green-500/50";
    case "qualified": return "bg-ism-teal/20 text-ism-teal border-ism-teal/50";
    case "contacted": return "bg-yellow-500/20 text-yellow-400 border-yellow-500/50";
    case "lost": return "bg-red-500/20 text-red-400 border-red-500/50";
    default: return "bg-gray-500/20 text-gray-400 border-gray-500/50";
  }
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const INPUT_CLS = "bg-white/5 border-gray-700 text-white text-sm";
